var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column items-center"},[_c('p',{staticClass:"q-ma-none"},[_vm._v(_vm._s(_vm.data.origin?_vm.data.origin.city:''))]),_c('p',{staticClass:"q-ma-none"},[_vm._v(_vm._s(_vm.data.origin?_vm.data.origin.state:''))]),_c('p',{staticClass:"q-ma-none"},[_vm._v(_vm._s(_vm.data.origin?_vm.data.origin.zipcode:''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }